/* GSH PDP v2 — 3D tilt (pairs with gsh-pdp2-enhance.css).
   Rahel perspektivni nagib galerije in kartic ob miški.
   Samo naprave z mišjo; spoštuje prefers-reduced-motion.
   Odstranljivo brez posledic (počisti inline transform ob mouseleave). */
(function(){
  function init(){
    if(window.matchMedia && !window.matchMedia('(hover:hover)').matches) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    var sel='.gp-gal__stage,.gp-ing__card,.gp-routine__card,.gp-proto__card,.gp-tier';
    document.querySelectorAll(sel).forEach(function(el){
      var strong=el.classList.contains('gp-gal__stage');
      var max=strong?7:4;
      el.style.transformStyle='preserve-3d';
      el.addEventListener('mousemove',function(e){
        var r=el.getBoundingClientRect();
        var px=(e.clientX-r.left)/r.width-0.5, py=(e.clientY-r.top)/r.height-0.5;
        el.style.transform='perspective(900px) rotateY('+(px*max).toFixed(2)+'deg) rotateX('+(-py*max).toFixed(2)+'deg)'+(strong?'':' translateY(-2px)');
      });
      el.addEventListener('mouseleave',function(){ el.style.transform=''; });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
